//  import theme from 'isAcme';
/*
 *
 * DEFAULT SETUPS FOR ACME
 * DEFAULT SETUPS FOR ACME
 * DEFAULT SETUPS FOR ACME
 *
 */


export const requiredColumns = [
  'amount',
  'category',
  'split',
  'postedOn',
  'payee',
  'select',
  'account',
  'accountColor',
  'menu',
];

export const availableColumns = {
  default: [
    'attachment',
    'match',
    'notes',
    'state',
    'tags',
    'userFlag',
    'ignored',
    'reviewed',
  ],
  manual: [
    'attachment',
    'balance',
    'match',
    'notes',
    'state',
    'tags',
    'userFlag',
    'ignored',
    'reviewed',
  ],
};

export const fieldData = {
  accountColor: { label: 'Account', sameAs: 'account', editable: true, position: 0, moveable: false, exportable: false },
  account: { label: 'Account', sameAs: 'accountColor', editable: true, position: 10, moveable: false, exportable: true },
  close: { label: 'Close', editable: true, position: 86, moveable: false, exportable: false },
  select: { label: 'Select', editable: true, position: 5, moveable: false, exportable: false },
  userFlag: { label: 'Flag', editable: true, position: 14, moveable: false, exportable: false },
  reviewed: { label: 'Reviewed', editable: true, position: 15, moveable: true, exportable: false },
  match: { label: 'Entry Method', editable: false, position: 20, moveable: true, exportable: false },
  state: { label: 'Status', editable: true, position: 27, moveable: true, exportable: true },
  postedOn: { label: 'Date', editable: true, position: 25, moveable: true, exportable: true },
  check: { label: 'Check #', editable: true, position: 30, moveable: true, exportable: true },
  payee: { label: 'Payee', editable: true, position: 35, moveable: true, exportable: true },
  category: { label: 'Category', editable: true, position: 40, moveable: true, exportable: true },
  split: { label: 'Split', editable: true, position: 40, moveable: false, exportable: false },
  tags: { label: 'Tags', editable: true, position: 45, moveable: true, exportable: true },
  notes: { label: 'Notes', editable: true, position: 50, moveable: true, exportable: true },
  attachment: { label: 'Attachment', editable: false, position: 60, moveable: true, exportable: false },
  expense: { label: 'Money Out', editable: true, position: 65, moveable: true, exportable: false },
  income: { label: 'Money In', editable: true, position: 70, moveable: true, exportable: false },
  amount: { label: 'Amount', editable: true, position: 75, moveable: true, exportable: true },
  balance: { label: 'Balance', editable: true, position: 80, moveable: true, exportable: false },
  save: { label: 'Save', editable: true, position: 85, moveable: false, exportable: false },
  ignored: { label: 'Ignored', editable: true, position: 88, moveable: false, exportable: false },
  menu: { label: 'Action Menu', editable: true, position: 90, moveable: false, exportable: false },
};

// This is the default columns shown, and default sort order
// This is used by QPreferences to initialize the state in preferences

export const columnDefaults = {
  default: [
    'accountColor', 'select', 'account', 'postedOn', 'state', 'payee', 'category', 'split', 'tags',
    'expense', 'income', 'amount', 'attachment', 'ignored', 'menu'],
  manual: [
    'accountColor', 'select', 'account', 'postedOn', 'state', 'payee', 'category', 'split', 'tags',
    'expense', 'income', 'amount', 'balance', 'attachment', 'ignored', 'menu'],
  all: [
    'accountColor', 'close', 'select', 'userFlag', 'reviewed', 'account', 'ignored', 'postedOn', 'payee',
    'category', 'split', 'tags', 'check', 'memo',
    'attachment', 'expense', 'income', 'amount', 'balance', 'save', 'close', 'menu'],
};


export const flagFieldOptions = [

  { label: 'Red', color: '#b13650', value: 'RED' },
  { label: 'Orange', color: '#ef7d5b', value: 'ORANGE' },
  { label: 'Yellow', color: '#ecdc5f', value: 'YELLOW' },
  { label: 'Green', color: '#34ab3c', value: 'GREEN' },
  { label: 'Blue', color: '#006fb3', value: 'BLUE' },
  { label: 'Violet', color: '#3b205c', value: 'VIOLET' },
  { label: 'Brown', color: '#00e1c7', value: 'BROWN' },
  { label: 'Black', color: '#000000', value: 'BLACK' },
  { label: 'None', color: 'rgba(0,0,0,0)', value: 'NONE' },
];

export const clrFieldOptions = {
  styles: (theme) => ({
    '&.Pending': {
      borderColor: theme.palette.greyScale[4],
      color: theme.palette.secondary.main,
      background: theme.palette.greyScale[6],
    },
    '&.Cleared': {
      borderColor: theme.palette.positiveLight,
      color: theme.palette.text.primary,
      background: theme.palette.greyScale[6],
    },
    '&.Upcoming': {
      borderColor: theme.palette.positiveLight,
      color: theme.palette.text.primary,
      background: theme.palette.greyScale[6],
    },
    '&.Today': {
      borderColor: theme.palette.positiveLight,
      color: theme.components.amountField.negativeColor2,
      background: theme.palette.greyScale[6],
    },
    '&.Past': {
      borderColor: theme.palette.positiveLight,
      color: theme.components.amountField.negativeColor,
      background: theme.palette.greyScale[6],
    },
    '&.No_Change': {
      borderColor: theme.palette.positiveLight,
      color: theme.palette.text.primary,
      background: theme.palette.greyScale[6],
    },
  }),
  options: [
    { label: 'Pending', state: 'PENDING', menu: true},
    { label: 'Cleared', state: 'CLEARED', menu: true},
    { label: 'Today', state: 'DUE', menu: false},
    { label: 'Past', state: 'OVERDUE', menu: false},
    { label: 'Upcoming', state: 'UPCOMING', menu: false},
  ],
};

//
// This array describes which fields are editable for recurring transactions
//
export const recurringEditable = columnDefaults.default; // ['account', 'menu', 'payee', 'state', 'category','postedOn', 'select', 'amount', 'income', 'expense', 'save', 'close'];
